module.exports = __webpack_public_path__ + "static/media/keyHolder.5df86721.png";